module.exports = __webpack_public_path__ + "static/img/video_7.bfe01de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_7.jpg
// module id = oULw
// module chunks = 1